import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './news-feed.reducer';

export const NewsFeedDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const newsFeedEntity = useAppSelector(state => state.newsFeed.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="newsFeedDetailsHeading">
          <Translate contentKey="fivePlusApp.newsFeed.detail.title">NewsFeed</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{newsFeedEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.newsFeed.description">Description</Translate>
            </span>
          </dt>
          <dd>{newsFeedEntity.description}</dd>
          <dt>
            <span id="imageName">
              <Translate contentKey="fivePlusApp.newsFeed.imageName">Image Name</Translate>
            </span>
          </dt>
          <dd>{newsFeedEntity.imageName}</dd>
          <dt>
            <span id="link">
              <Translate contentKey="fivePlusApp.newsFeed.link">Link</Translate>
            </span>
          </dt>
          <dd>{newsFeedEntity.link}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fivePlusApp.newsFeed.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {newsFeedEntity.createdDate ? <TextFormat value={newsFeedEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="modifiedDate">
              <Translate contentKey="fivePlusApp.newsFeed.modifiedDate">Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {newsFeedEntity.modifiedDate ? <TextFormat value={newsFeedEntity.modifiedDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="videoFile">
              <Translate contentKey="fivePlusApp.newsFeed.videoFile">Video File</Translate>
            </span>
          </dt>
          <dd>{newsFeedEntity.videoFile}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.newsFeed.user">User</Translate>
          </dt>
          <dd>{newsFeedEntity.user ? newsFeedEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/news-feed" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/news-feed/${newsFeedEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NewsFeedDetail;
